<template>
  <div>
    <v-container>
      <v-row justify="center">
        <h1>Security</h1>
      </v-row>
    </v-container>
    <v-container>
      <v-row justify="center">
        <p>Account security and recommendations</p>
      </v-row>
    </v-container>

  </div>
</template>

<script>

export default {
  name: "PersonalData",
  components: {

  },
  data() {
    return {
    }
  },
  computed: {
    
  },
  mounted() {},
  methods: {
    
  }
};
</script>

<style scoped>
h2 {
  color: #4dbac0;
  font-family: "Roboto", "Roboto Condensed Bold", sans-serif !important;
  font-size: 16px;
}
.record-card {
  width: 100%;
  float: left;
  background-color: #2d3540;
  padding: 13px 15px 15px 15px;
  border-radius: 3px;
  margin-bottom: 1px;
  min-height: 68px;
  cursor: pointer;
  font-size: 12px;
}

.record-card:hover {
  background: #232a35;
}
.tag {
  color: #b6c1cb;
  text-transform: uppercase;
}
.tag-value {
  font-size: 16px;
}
.avatar {
  border: 10px solid #333b47;
}
</style>